import { getNameByFinancialCompanyCode, PAYMENT_METHOD_LABEL } from '@common/constants';

type Language = 'ko' | 'en' | 'ja';

import { PaymentMethod } from '../graphql/maximum-benefit_types.2';
import { convertCodeOrMethodToCardName } from './convertCodeOrMethodToCardName';

export function formatPaymentMethodLabel(
  language: Language,
  companyCode: string,
  payment_method: PaymentMethod,
  payment_method_type: string | null,
) {
  switch (payment_method_type) {
    case 'CARD':
      return (
        PAYMENT_METHOD_LABEL[payment_method as keyof typeof PaymentMethod][language] +
        ' X ' +
        getNameByFinancialCompanyCode(language, companyCode)
      );
    case 'MONEY':
      return (
        PAYMENT_METHOD_LABEL[payment_method as keyof typeof PaymentMethod][language] +
        `${payment_method === PaymentMethod.TOSSPAY ? '계좌' : '머니'} ` +
        getNameByFinancialCompanyCode(language, companyCode)
      );
    default:
      return convertCodeOrMethodToCardName(language, companyCode, payment_method);
  }
}

// MEMO: 네이티브 PDP 서버에서 내려주는 키 값이 formatPaymentMethodLabel 함수 리턴값과 다르기 때문에 추가
export function formatPaymentMethodLabelKey(
  language: Language,
  companyCode: string,
  payment_method: PaymentMethod,
  payment_method_type: string | null,
) {
  switch (payment_method_type) {
    case 'CARD':
      return (
        PAYMENT_METHOD_LABEL[payment_method as keyof typeof PaymentMethod][language] +
        ' X ' +
        getNameByFinancialCompanyCode(language, companyCode)
      );
    case 'MONEY':
      return (
        PAYMENT_METHOD_LABEL[payment_method as keyof typeof PaymentMethod][language] +
        getNameByFinancialCompanyCode(language, companyCode)
      );
    default:
      return convertCodeOrMethodToCardName(language, companyCode, payment_method);
  }
}
